const init = function () {
    const pageId = document.querySelector('[data-page="inventory"]');
    if (!pageId) {
        return;
    }
    const table = document.getElementById('inventoryTable');

    function recalculateRow(tr) {
        const fakt = parseFloat(tr.querySelector('.item-fakt').value) || 0;
        const raschet = parseFloat(tr.querySelector('.item-raschet').value) || 0;
        const cena = parseFloat(tr.querySelector('.item-cena').value) || 0;

        const raznica = fakt - raschet;
        const summa = raznica * cena;

        tr.querySelector('.item-raznica').textContent = raznica.toFixed(3);
        tr.querySelector('.item-raznica').className = 'item-raznica ' + (raznica < 0 ? 'text-danger' : (raznica > 0 ? 'text-success' : 'text-muted'));
        tr.querySelector('.item-summa').textContent = summa.toFixed(2);

        recalculateTotals();
    }

    function recalculateTotals() {
        let totalRaznica = 0;
        let totalSumma = 0;

        table.querySelectorAll('tbody tr').forEach(tr => {
            totalRaznica += parseFloat(tr.querySelector('.item-raznica').textContent) || 0;
            totalSumma += parseFloat(tr.querySelector('.item-summa').textContent) || 0;
        });

        document.getElementById('totalRaznica').textContent = totalRaznica.toFixed(3);
        document.getElementById('inputTotalRaznica').value = totalRaznica;

        document.getElementById('totalSumma').textContent = totalSumma.toFixed(2);
        document.getElementById('inputTotalSumma').value = totalSumma;
    }

    table.addEventListener('input', function (e) {
        if (e.target.classList.contains('item-fakt') || e.target.classList.contains('item-cena')) {
            recalculateRow(e.target.closest('tr'));
        }
    });

    // Initial calculation
    table.querySelectorAll('tbody tr').forEach(tr => recalculateRow(tr));

    // Autofill Logic (The data was already loaded with calculated defaults,
    // but we can add a button to reset or fetch live if needed.
    // For now, the "Auto-fill" button just resets Fakt to Raschet.)
    document.getElementById('btnAutofill').onclick = function () {
        if (confirm('Сбросить фактические значения к расчетным?')) {
            table.querySelectorAll('tbody tr').forEach(tr => {
                const raschet = tr.querySelector('.item-raschet').value;
                tr.querySelector('.item-fakt').value = raschet;
                recalculateRow(tr);
            });
        }
    };
}


export default {init};
// document.addEventListener('DOMContentLoaded', function() {
//     const table = document.getElementById('inventoryTable');
//
//     function recalculateRow(tr) {
//         const fakt = parseFloat(tr.querySelector('.item-fakt').value) || 0;
//         const raschet = parseFloat(tr.querySelector('.item-raschet').value) || 0;
//         const cena = parseFloat(tr.querySelector('.item-cena').value) || 0;
//
//         const raznica = fakt - raschet;
//         const summa = raznica * cena;
//
//         tr.querySelector('.item-raznica').textContent = raznica.toFixed(3);
//         tr.querySelector('.item-raznica').className = 'item-raznica ' + (raznica < 0 ? 'text-danger' : (raznica > 0 ? 'text-success' : 'text-muted'));
//         tr.querySelector('.item-summa').textContent = summa.toFixed(2);
//
//         recalculateTotals();
//     }
//
//     function recalculateTotals() {
//         let totalRaznica = 0;
//         let totalSumma = 0;
//
//         table.querySelectorAll('tbody tr').forEach(tr => {
//             totalRaznica += parseFloat(tr.querySelector('.item-raznica').textContent) || 0;
//             totalSumma += parseFloat(tr.querySelector('.item-summa').textContent) || 0;
//         });
//
//         document.getElementById('totalRaznica').textContent = totalRaznica.toFixed(3);
//         document.getElementById('inputTotalRaznica').value = totalRaznica;
//
//         document.getElementById('totalSumma').textContent = totalSumma.toFixed(2);
//         document.getElementById('inputTotalSumma').value = totalSumma;
//     }
//
//     table.addEventListener('input', function(e) {
//         if (e.target.classList.contains('item-fakt') || e.target.classList.contains('item-cena')) {
//             recalculateRow(e.target.closest('tr'));
//         }
//     });
//
//     // Initial calculation
//     table.querySelectorAll('tbody tr').forEach(tr => recalculateRow(tr));
//
//     document.getElementById('btnAutofill').onclick = function() {
//         if(confirm('Сбросить фактические значения к расчетным?')) {
//             table.querySelectorAll('tbody tr').forEach(tr => {
//                 const raschet = tr.querySelector('.item-raschet').value;
//                 tr.querySelector('.item-fakt').value = raschet;
//                 recalculateRow(tr);
//             });
//         }
//     };
// });
